module.exports = __webpack_public_path__ + "img/decoration-05.6fbbcbb.svg";